"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { SingleWaveDropWrapper } from "./SingleWaveDropWrapper";
import { SingleWaveDropInfoPanel } from "./SingleWaveDropInfoPanel";
import { useSingleWaveDropData } from "./useSingleWaveDropData";
interface DefaultSingleWaveDropProps {
  readonly drop: ExtendedDrop;
  readonly onClose: () => void;
}
export const DefaultSingleWaveDrop: React.FC<DefaultSingleWaveDropProps> = t0 => {
  const $ = _c(7);
  const {
    drop: initialDrop,
    onClose
  } = t0;
  const {
    drop,
    wave,
    extendedDrop
  } = useSingleWaveDropData(initialDrop, onClose);
  if (!extendedDrop || !wave || !drop) {
    return null;
  }
  let t1;
  if ($[0] !== extendedDrop) {
    t1 = <SingleWaveDropInfoPanel drop={extendedDrop} />;
    $[0] = extendedDrop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop || $[3] !== onClose || $[4] !== t1 || $[5] !== wave) {
    t2 = <SingleWaveDropWrapper drop={drop} wave={wave} onClose={onClose}>{t1}</SingleWaveDropWrapper>;
    $[2] = drop;
    $[3] = onClose;
    $[4] = t1;
    $[5] = wave;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};